import { CartItem } from './CartItem'

export enum ShippingSet {
  'XY-SHIPPING-00-01' = 'XY-SHIPPING-00-01', // $0.01
  'XY-SHIPPING-00-45' = 'XY-SHIPPING-00-45', // $0.45
  'XY-SHIPPING-00-95' = 'XY-SHIPPING-00-95', // $0.95
  'XY-SHIPPING-01-95' = 'XY-SHIPPING-01-95', // $1.95
  'XY-SHIPPING-03-95' = 'XY-SHIPPING-03-95', // $3.95
  'XY-SHIPPING-04-95' = 'XY-SHIPPING-04-95', // $4.95
  'XY-SHIPPING-06-95' = 'XY-SHIPPING-06-95', // $6.95
  'XY-SHIPPING-09-95' = 'XY-SHIPPING-09-95', // $9.95
  'XY-SHIPPING-12-95' = 'XY-SHIPPING-FULL-2', // $12.95 <~ Because there has to be one gotcha
  'XY-SHIPPING-17-95' = 'XY-SHIPPING-17-95', // $17.95
  'XY-SHIPPING-24-95' = 'XY-SHIPPING-24-95', // $24.95
}

export const Shipping1: CartItem = {
  COGS: 5,
  defaultAdd: true,
  msrp: 12.95,
  planId: ShippingSet['XY-SHIPPING-00-01'],
  price: 0.01,
  quantity: 1,
  ship: true,
  subtitle: '',
  title: 'Shipping Cost: $0.01 (price you pay)',
  value: 0.01,
  name: '$0.01 (price you pay)',
}

export const Shipping45: CartItem = {
  COGS: 5,
  defaultAdd: true,
  msrp: 12.95,
  planId: ShippingSet['XY-SHIPPING-00-45'],
  price: 0.45,
  quantity: 1,
  ship: true,
  subtitle: '',
  title: 'Shipping Cost: $0.45 (price you pay)',
  value: 0.45,
  name: '$0.45 (price you pay)',
}

export const Shipping95: CartItem = {
  COGS: 5,
  defaultAdd: true,
  msrp: 12.95,
  planId: ShippingSet['XY-SHIPPING-00-95'],
  price: 0.95,
  quantity: 1,
  ship: true,
  subtitle: '',
  title: 'Shipping Cost: $0.95 (price you pay)',
  value: 0.95,
  name: '$0.95 (price you pay)',
}

export const Shipping195: CartItem = {
  COGS: 5,
  defaultAdd: true,
  msrp: 12.95,
  planId: ShippingSet['XY-SHIPPING-01-95'],
  price: 1.95,
  quantity: 1,
  ship: true,
  subtitle: '',
  title: 'Shipping Cost: $1.95 (price you pay)',
  value: 1.95,
  name: '$1.95 (price you pay)',
}
export const Shipping395: CartItem = {
  COGS: 5,
  defaultAdd: true,
  msrp: 12.95,
  planId: ShippingSet['XY-SHIPPING-03-95'],
  price: 3.95,
  quantity: 1,
  ship: true,
  subtitle: '',
  title: 'Shipping Cost: $3.95 (price you pay)',
  value: 3.95,
  name: '$3.95 (price you pay)',
}

export const Shipping495: CartItem = {
  COGS: 5,
  defaultAdd: true,
  msrp: 12.95,
  planId: ShippingSet['XY-SHIPPING-04-95'],
  price: 4.95,
  quantity: 1,
  ship: true,
  subtitle: '',
  title: 'Shipping Cost: $4.95 (price you pay)',
  value: 4.95,
  name: '$4.95 (price you pay)',
}
export const Shipping695: CartItem = {
  COGS: 5,
  defaultAdd: true,
  msrp: 12.95,
  planId: ShippingSet['XY-SHIPPING-06-95'],
  price: 6.95,
  quantity: 1,
  ship: true,
  subtitle: '',
  title: 'Shipping Cost: $6.95 (price you pay)',
  value: 6.95,
  name: '$6.95 (price you pay)',
}

export const Shipping995: CartItem = {
  COGS: 5,
  defaultAdd: true,
  msrp: 12.95,
  planId: ShippingSet['XY-SHIPPING-09-95'],
  price: 9.95,
  quantity: 1,
  ship: true,
  subtitle: '',
  title: 'Shipping Cost: $9.95 (price you pay)',
  value: 9.95,
  name: '$9.95 (price you pay)',
}

export const Shipping1295: CartItem = {
  COGS: 5,
  defaultAdd: true,
  msrp: 12.95,
  planId: ShippingSet['XY-SHIPPING-12-95'],
  price: 12.95,
  quantity: 1,
  ship: true,
  subtitle: '',
  title: 'Shipping & Configuration*: $12.95',
  name: '$12.95 (price you pay)',
  value: 12.95,
}

export const Shipping1795: CartItem = {
  COGS: 5,
  defaultAdd: true,
  msrp: 12.95,
  planId: ShippingSet['XY-SHIPPING-17-95'],
  price: 17.95,
  quantity: 1,
  ship: true,
  subtitle: '',
  title: 'Shipping Cost: $17.95 (price you pay)',
  name: '$17.95 (price you pay)',
  value: 17.95,
}

export const Shipping2495: CartItem = {
  COGS: 5,
  defaultAdd: true,
  msrp: 12.95,
  planId: ShippingSet['XY-SHIPPING-24-95'],
  price: 24.95,
  quantity: 1,
  ship: true,
  subtitle: '',
  title: 'Shipping Cost: $24.95 (price you pay)',
  name: '$24.95 (price you pay)',
  value: 24.95,
}
